import { Link } from "gatsby"
import React, { useEffect, useState } from "react"
import linkBuilder from "../../modules/linkBuilder"
import MegaMenu from "../mega-menu/mega-menu"
import {
  desktopNav,
  list,
  listItem,
  listItemHover,
  hover,
  categoryList,
  categoryListItem,
  megaMenu,
} from "./desktop-nav.module.css"
import { dataLayer, trackEvent } from "../../modules/analytics"

const DesktopNav = ({ desks }) => {
  const [desksToShow, setDesksToShow] = useState(
    desks.filter((_, index) => index < 6)
  )

  useEffect(() => {
    const sortedDesks = desks
      .sort((a, b) => {
        if (a.sortNavigation === null) return 1
        if (b.sortNavigation === null) return -1
        return a.sortNavigation - b.sortNavigation
      })
      .filter((_, index) => index < 6)
    setDesksToShow(sortedDesks)
  }, [desks])

  const [showNavHover, setShowNavHover] = useState({})

  const handleMouseOver = (id) => {
    setShowNavHover({ [id]: true })
  }

  const handleMouseLeave = (id) => {
    setShowNavHover({ [id]: false })
  }

  return (
    <div className={desktopNav}>
      <ul className={list}>
        {desksToShow &&
          desksToShow.map((desk) => (
            <li
              key={desk.id}
              className={`${listItem} ${showNavHover[desk.id] && listItemHover
                }`}
              onMouseOver={() => handleMouseOver(desk.id)}
              onMouseLeave={() => handleMouseLeave(desk.id)}
            >
              <Link
                to={linkBuilder.desk(desk)}
                onClick={() => trackEvent(`nav_hero`)}
              >
                <span>{desk.name}</span>
              </Link>

              {showNavHover[desk.id] && <DesktopNavHover desk={desk} />}
            </li>
          ))}
        <li className={megaMenu}>
          <MegaMenu desks={desks} />
        </li>
      </ul>
    </div>
  )
}

const DesktopNavHover = ({ desk }) => {
  return (
    <div className={hover}>
      <ul className={categoryList}>
        {desk?.deskcategory?.map((category) => (
          <Link
            key={category.id}
            to={linkBuilder.deskCategory({ ...category, desk: desk })}
            onClick={() => trackEvent(`nav_hub`)}
          >
            <li className={categoryListItem}>{category.name}</li>
          </Link>
        ))}
      </ul>
    </div>
  )
}

export default DesktopNav
